import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getRWPDictTreeApi,
    getRWPPaginationDataApi,
    postRWPDataApi,
    putRWPDataApi,
    deletRWPTableDataApi,
    getRWPDataApi,
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    dictData: null, // 数据字典
    paginatedData: null, // 分页数据
    idData: null, // 单条回显数据
    pageNum: 1, // 初始分页数
    locationName: '', // location 名称
    locationId: '', // location id
}

/* 获取数据字典 */
export const getRWPDictDataAction = createAsyncThunk('RWPSlice/getRWPDictDataAction', async (dictType, thunkAPI) => {
    const priorityTypeDataDict = getRWPDictTreeApi(dictType[0])
    const responsibleTypeDataDict = getRWPDictTreeApi(dictType[1])
    const companyTypeDataDict = getRWPDictTreeApi(dictType[2])
    const sourceTypeDataDict = getRWPDictTreeApi(dictType[3])
    const stausDataDict = getRWPDictTreeApi(dictType[4])
    const departmentDataDict = getRWPDictTreeApi(dictType[5])
    const hazardCatDataDict1 = getRWPDictTreeApi(dictType[6])
    const hazardCatDataDict2 = getRWPDictTreeApi(dictType[7])
    const consequenceDataDict = getRWPDictTreeApi(dictType[8])
    const uaucDataDict2 = getRWPDictTreeApi(dictType[9])
    return Promise.all([priorityTypeDataDict, responsibleTypeDataDict, companyTypeDataDict, sourceTypeDataDict, stausDataDict, departmentDataDict, hazardCatDataDict1, hazardCatDataDict2, consequenceDataDict, uaucDataDict2])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 查询分页数据 */
export const getRWPPaginationDataAction = createAsyncThunk(
    'RWPSlice/getRWPPaginationDataAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getRWPPaginationDataApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 新增数据 */
export const postRWPDataAction = createAsyncThunk(
    'RWPSlice/postRWPDataAction',
    async ({ params, modalAddNew }, thunkAPI) => {
        try {
            if (modalAddNew) {
                const data = await postRWPDataApi(params)
                return data
            } else {
                const data = await putRWPDataApi(params)
                return data
            }
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 删除 RWP 表格单条数据 */
export const deletRWPTableDataAction = createAsyncThunk('RWPSlice/deletRWPTableDataAction', async (id, thunkAPI) => {
    try {
        const { data } = await deletRWPTableDataApi(id)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 通过 id 获取单条 RWP */
export const getRWPDataAction = createAsyncThunk('ProjectManagementSlice/getRWPDataAction', async (id, thunkAPI) => {
    try {
        const { data } = await getRWPDataApi(id)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

export const RWPSlice = createSlice({
    name: 'RWPSlice',
    initialState,
    reducers: {
        changepPageNum: (state, action) => {
            state.pageNum = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
    },
    extraReducers: {
        /* 处理数据字典 */
        [getRWPDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        /* 分页数据 */
        [getRWPPaginationDataAction.fulfilled.type]: (state, action) => {
            state.paginatedData = action.payload
        },

        /* 通过 id 获取单条 RWP */
        [getRWPDataAction.fulfilled.type]: (state, action) => {
            state.idData = action.payload
        },
    },
})
